export const MESSAGES_LOAD_SUCCESS = 'MESSAGES_LOAD_SUCCESS';
export const MESSAGES_LOAD_ERROR = 'MESSAGES_LOAD_ERROR';
export const MESSAGES_BANNER_LOAD = 'MESSAGES_BANNER_LOAD';
